/**
 * Flags the page as scrolled to the very bottom (html.dc-at-page-bottom) so
 * assets/dc-core-theme.css can hide the Stamped rewards launcher
 * (.stamped-launcher-button) on mobile once it reaches the bottom — it is
 * fixed to the bottom-right corner and would otherwise sit on top of the
 * footer's last row (copyright / SNS icons).
 */
(() => {
  // A few px of slack: mobile browsers report fractional scroll positions.
  const THRESHOLD = 10;
  const root = document.documentElement;
  let ticking = false;

  function update() {
    ticking = false;
    const atBottom = window.innerHeight + window.scrollY >= root.scrollHeight - THRESHOLD;
    root.classList.toggle('dc-at-page-bottom', atBottom);
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  schedule();
})();

/**
 * Buttons that open the Stamped Rewards launcher on a given view:
 *   <button data-dc-rewards-view="view-spendings">  documented view ids
 *     (view-spendings / view-earnings / view-your-rewards /
 *     view-referrals-email) → StampedFn.loadLauncherView()
 *   <button data-dc-rewards-view="reviews">  no API for this one (the
 *     launcher's 口コミ tab) → open the launcher, then click its own
 *     [data-target="reviews"] button once it has rendered.
 * Used by sections/dc-review-guide.liquid. Does nothing until StampedFn
 * (Stamped app embed) has loaded.
 */
(() => {
  const WAIT_MS = 4000;
  const STEP_MS = 100;

  // The launcher may render in the page or in a same-origin iframe.
  function findTarget(name) {
    const selector = '[data-target="' + name + '"]';
    const found = document.querySelector(selector);
    if (found) return found;
    for (const frame of document.querySelectorAll('iframe')) {
      try {
        const el = frame.contentDocument && frame.contentDocument.querySelector(selector);
        if (el) return el;
      } catch (e) {
        // cross-origin frame — not the launcher
      }
    }
    return null;
  }

  function clickWhenReady(name) {
    const started = Date.now();
    (function tick() {
      const el = findTarget(name);
      if (el) return el.click();
      if (Date.now() - started < WAIT_MS) setTimeout(tick, STEP_MS);
    })();
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('[data-dc-rewards-view]');
    if (!button || !window.StampedFn) return;
    event.preventDefault();
    const view = button.dataset.dcRewardsView;
    window.StampedFn.toggleRewardsModal();
    if (/^view-/.test(view)) window.StampedFn.loadLauncherView(view);
    else clickWhenReady(view);
  });
})();
